<script setup>
import { PresentationChartLineIcon } from '@heroicons/vue/outline'

const props = defineProps({
  data: {
    type: Object,
    required: true,
  }
})
</script>

<template>
  <a :href="route('admin.graphs.show')" class="flex justify-center items-center flex-col bg-gray-200 rounded-md px-4">
    <div class="block text-xs -mb-1">
      Totaal deze maand:
    </div>
    <div class="w-full flex justify-center items-center text-sm">
      € {{ data.totals }}
      <div class="w-4 h-4 inline-block ml-4">
        <PresentationChartLineIcon />
      </div>
    </div>
  </a>
</template>
